import styled from 'styled-components'
import { Avatar } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import type { PaymentCardTeamMember } from '../../hooks/usePaymentCards'

type TeamMembersSectionProps = {
  label: string
  members?: PaymentCardTeamMember[]
  emptyText: string
}

const TeamMembersSection = ({
  label,
  members,
  emptyText
}: TeamMembersSectionProps) => (
  <Wrapper>
    <Label level={2}>{label}</Label>
    {!members?.length ? (
      <Value>{emptyText}</Value>
    ) : (
      <MembersList>
        {members.map((member) => (
          <MemberRow key={member.id}>
            <Avatar url={member.picture} size={24} />
            <Value>
              {member.name.first} {member.name.last}
            </Value>
          </MemberRow>
        ))}
      </MembersList>
    )}
  </Wrapper>
)

const Wrapper = styled.div``

const Label = styled(Text)`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

const MembersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
`

const MemberRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export default TeamMembersSection
